// re-push trigger
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const email = localStorage.getItem('teacherEmail');
  const role = localStorage.getItem('teacherRole');



  const handleLogout = () => {
    localStorage.removeItem('teacherEmail');
    localStorage.removeItem('teacherRole');
    navigate('/login'); // مسیر صفحه ورود
  };

  const navItems = [
    { to: '/admin/attendance', label: '📋 مدیریت غایبین' },
    { to: '/teachers', label: '👩‍🏫 مدیریت معلم‌ها' },
    { to: '/teacher-lessons', label: '📘 درس پایه' },
    { to: '/students', label: '👨‍🎓 مدیریت دانش‌آموزان' },
    { to: '/questions', label: '❓ مدیریت سوالات' },
    { to: '/add-question', label: '➕ افزودن سوال جدید' },
    { to: '/activity-log', label: '📊 گزارش فعالیت‌ها' },
    { to: '/attendance', label: '🗓️ حضور و غیاب' },
    { to: '/add-student', label: '➕ افزودن دانش‌آموز جدید' },
  ];

  return (
    <div dir="rtl" style={{
      padding: '2rem',
      fontFamily: 'Tahoma, sans-serif',
      backgroundColor: '#F9FAFB',
      minHeight: '100vh'
    }}>
      {/* دکمه خروج */}
      <div style={{ textAlign: 'left', marginBottom: '1rem' }}>
        <button
          onClick={handleLogout}
          style={{
            backgroundColor: '#EF4444',
            color: '#FFFFFF',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          🚪 خروج
        </button>
      </div>

      {/* کارت خوش‌آمدگویی */}
      <div style={{
        backgroundColor: '#E0F2FE',
        padding: '1.5rem',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        marginBottom: '2rem'
      }}>
        <h2 style={{ margin: 0, color: '#1E40AF' }}>🛠️ داشبورد مدیریت</h2>
        <p style={{ marginTop: '0.5rem', color: '#374151' }}>
          خوش آمدید <strong>{email}</strong> (نقش: <strong>{role}</strong>)
        </p>
      </div>

      {/* منوی مدیریت */}
      <nav>
        <ul style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '1rem',
          listStyle: 'none',
          padding: 0,
          margin: 0
        }}>
          {navItems.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.to}
                style={{
                  display: 'block',
                  backgroundColor: '#FFFFFF',
                  padding: '1rem',
                  borderRadius: '10px',
                  textDecoration: 'none',
                  color: '#1F2937',
                  fontWeight: 'bold',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                  transition: 'all 0.2s ease-in-out'
                }}
                activeStyle={{
                  backgroundColor: '#DBEAFE',
                  color: '#1E3A8A'
                }}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default AdminDashboard;